import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DomainEventBus, DomainEventType } from '../events/domain-event-bus';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private _loader = new Subject<boolean>();
  public loader$ = this._loader.asObservable();
  constructor(private bus: DomainEventBus) {}

  showLoader() {
    this._toggleLoader(true);
  }

  hideLoader() {
    this._toggleLoader(false);
  }

  private _toggleLoader(flag: boolean) {
    this._loader.next(flag);
    this.bus.emit({ type: DomainEventType.LoaderVisible, visible: flag });
  }
}
